import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

// helpers
import tracking from 'dibs-tracking';

function trackViewInvoice() {
    tracking.trackEvent({
        category: 'product',
        action: 'view invoice',
        label: 'pdp description',
    });
}

function PdpSharedDetailItemInvoice({ itemId }) {
    return (
        <span data-tn="pdp-spec-item-invoice">
            <FormattedMessage
                id="pdpDetails.invoiceText"
                defaultMessage="Generate an invoice that you can customize and print."
            />
            <div onClick={trackViewInvoice}>
                <a href={`/my/orders/invoice/id-${itemId}`} target="_blank">
                    <FormattedMessage id="pdpDetails.invoiceLink" defaultMessage="View Invoice" />
                </a>
            </div>
        </span>
    );
}

PdpSharedDetailItemInvoice.propTypes = {
    itemId: PropTypes.string.isRequired,
};

export default PdpSharedDetailItemInvoice;
